import { createFileRoute } from "@tanstack/react-router";

import { HaInstanceListPanel } from "../features/haInstances/HaInstanceListPanel";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances",
)({
  component: HaInstanceListRoute,
});

function HaInstanceListRoute() {
  const { accountSlug, tenantSlug } = Route.useParams();
  return (
    <HaInstanceListPanel accountSlug={accountSlug} tenantSlug={tenantSlug} />
  );
}
